export default {
	security: {
		securityBind: "Ikatan Keselamatan",
		securitySettings: "Tetapan Keselamatan",
		level: "Sederhana",
		confirm: "Sahkan",
		submitting: "Menghantar...",
		add: "Tambah",
		change: "Tukar",
		success: "Berjaya dikemas kini",
		select: "Pilih",

		birthday: "Hari Lahir Kenalan",
		birthdayDesc: "Ikat hari lahir kenalan untuk komunikasi yang lebih mudah. Maklumat peribadi anda akan terus dilindungi.",
		month: "Bulan",
		day: "Hari",
		year: "Tahun",
		birthdayRequired: "Hari lahir diperlukan.",
		invalidBirthday: "Hari lahir tidak sah.",
		invalidMonth: "Bulan tidak sah.",
		invalidDay: "Hari tidak sah.",
		invalidYear: "Tahun tidak sah.",
		updateBirthdayFail: "Gagal mengemas kini hari lahir",
		birthdayVerify: "Pengesahan ikatan hari lahir",
		birthdayVerifyDesc: "Ikat hari lahir anda untuk meningkatkan keselamatan akaun anda.",

		email: "E-mel Kenalan",
		emailDesc: "E-mel untuk keselamatan akaun. Hanya anda yang boleh mengikatnya.",
		emailRequired: "E-mel diperlukan.",
		emailInvalid: "Alamat e-mel salah.",
		updateEmailFail: "Gagal mengemas kini e-mel",
		emailVerify: "Pengesahan ikatan e-mel",
		emailVerifyDesc: "Sahkan alamat e-mel anda untuk meningkatkan keselamatan akaun anda.",

		phone: "Nombor Telefon",
		bindPhone: "Ikat Nombor Telefon",
		phoneDesc: "Nombor telefon untuk keselamatan akaun. Hanya anda yang boleh mengikatnya.",
		phoneRequired: "Nombor telefon diperlukan.",
		phoneUsed: "Sila gunakan nombor telefon yang berbeza.",
		updatePhoneFail: "Gagal mengemas kini nombor telefon",
		noCode: "Tiada kod diterima?",
		smsHelp: "Jika anda telah mencuba beberapa kali tetapi masih belum menerima kod pengesahan.",
		smsTips1: "1. Semak sama ada nombor telefon bimbit yang anda masukkan adalah betul.",
		smsTips2: "2. Semak sama ada nombor telefon bimbit anda sudah lapuk.",
		smsTips3: "3. Semak sama ada mesej berada dalam peti SMS.",
		smsTips4: "4. Mesej mungkin lewat beberapa minit.",
		phoneVerify: "Pengesahan ikatan nombor telefon",
		phoneVerifyDesc: "Sahkan nombor telefon anda untuk meningkatkan keselamatan akaun anda.",

		setPassword: "Tetapkan Kata Laluan",
		passwordDesc: "Tetapkan kata laluan log masuk anda.",
		clickSelectBirthday: "Klik untuk pilih tarikh lahir",
		selectBirthday: "Pilih Tarikh Lahir",
		confirm: "Sahkan",
		cancel: "Batal",
		withdrawPassword: "Kata Laluan Pengeluaran",
		withdrawpasswordDesc: "Tetapkan kata laluan pengeluaran wang anda.",
		set: "Tetapkan",
	},

	contactPhone: {
		title: "Tukar Nombor Telefon",
		titleMobile: "Tukar",
		description: "Tambah nombor telefon hubungan untuk komunikasi yang lebih mudah. Maklumat peribadi anda akan dilindungi.",
		label: "Nombor Telefon Hubungan",
		confirm: "Sahkan",
		submitting: "Sedang menghantar...",
		required: "Nombor telefon diperlukan",
		invalid: "Nombor telefon tidak sah",
		success: "Nombor telefon berjaya dikemas kini!",
		updateFailed: "Kemas kini gagal",
		tryAgain: "Kemas kini gagal, sila cuba lagi kemudian",
		verifyTitleMobile: "Pengesahan Telefon",
		titleMobile: "Pautkan Telefon",
		changeTitleMobile: "Tukar Telefon",
		securityTip: "Telefon untuk keselamatan akaun. Hanya anda yang boleh memautkannya.",
		placeholder: "Nombor Telefon",
		noCodeReceived: "Tidak menerima kod?",
		codeDescription: "Masukkan 6 digit kod pengesahan yang dihantar ke butiran hubungan anda di bawah:",
		resendIn: "Hantar semula dalam {countdown} s",
		resend: "Hantar semula",
		submitting: "Menyerahkan...",
		confirm: "Sahkan",
		invalidCode: "Sila masukkan 6 digit kod yang sah",
		required: "Nombor telefon diperlukan",
		invalid: "Sila masukkan nombor telefon yang sah",
		success: "Berjaya dikemas kini",
		updateFailed: "Gagal dikemas kini",
		tryAgain: "Sila cuba lagi kemudian"
	},

	contactEmail: {
		title: "Tukar Email",
		titleMobile: "Tukar",
		description: "Tambah email hubungan untuk komunikasi yang lebih mudah. Maklumat peribadi anda akan dilindungi.",
		label: "Email Hubungan",
		placeholder: "Email",
		confirm: "Sahkan",
		submitting: "Sedang menghantar...",
		required: "Email tidak boleh kosong",
		invalid: "Sila masukkan alamat email yang sah",
		success: "Email berjaya dikemas kini!",
		updateFailed: "Kemas kini gagal",
		tryAgain: "Kemas kini gagal, sila cuba lagi kemudian",
		verifyTitleMobile: "Pengesahan E-mel",
		titleMobile: "Pautkan E-mel",
		changeTitleMobile: "Tukar E-mel",
		securityTip: "E-mel untuk keselamatan akaun. Hanya anda yang boleh memautkannya.",
		noCodeReceived: "Tidak menerima kod?",
		codeDescription: "Masukkan 6 digit kod pengesahan yang dihantar ke butiran hubungan anda di bawah:",
		resendIn: "Hantar semula dalam {countdown} s",
		resend: "Hantar semula",
		submitting: "Menyerahkan...",
		confirm: "Sahkan",
		invalidCode: "Sila masukkan 6 digit kod yang sah",
		required: "E-mel diperlukan",
		invalid: "Sila masukkan alamat e-mel yang sah",
		success: "Berjaya dikemas kini",
		updateFailed: "Gagal dikemas kini",
		tryAgain: "Sila cuba lagi kemudian"
	},

	accountInfo: {
		profileInfo: "Maklumat Profil",
		contactInfo: "Maklumat Hubungan",
		privacy: "Privasi",
		contactEmail: "Email Hubungan",
		contactPhone: "Nombor Telefon Hubungan",
		addEmailDesc: "Tambah email hubungan untuk komunikasi yang lebih mudah. Maklumat peribadi anda akan dilindungi.",
		addPhoneDesc: "Tambah nombor telefon hubungan untuk komunikasi yang lebih mudah. Maklumat peribadi anda akan dilindungi.",
		hideUsername: "Sembunyikan nama pengguna saya dari senarai awam",
		add: "Tambah",
		change: "Tukar",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "PEMAIN",
		copied: "Disalin!",
		hideSuccess: "Nama pengguna berjaya disembunyikan",
		showSuccess: "Nama pengguna berjaya ditunjukkan",
		operationFailed: "Operasi gagal",
		editProfile: "Edit Profil",
		contactInfo: "Info Hubungan",
		contactEmail: "E-mel Hubungan",
		emailTip: "Tambah e-mel hubungan untuk komunikasi yang lebih mudah. Maklumat peribadi anda akan kekal dilindungi.",
		change: "Tukar",
		addEmail: "Tambah E-mel",
		contactPhone: "Nombor Telefon Hubungan",
		phoneTip: "Tambah nombor telefon anda untuk pengesahan akaun yang selamat.",
		addPhone: "Tambah Nombor Telefon",
		birthdayBind: "Pengesahan pautan hari lahir",
		birthdayTip: "Pautkan hari lahir anda untuk meningkatkan keselamatan akaun anda.",
		addBirthday: "Tambah Hari Lahir",
		personalInfo: "Info Peribadi",
		personalTip: "Sahkan identiti anda untuk membuka lebih banyak perkhidmatan. Data anda selamat.",
		verifyNow: "Sahkan Sekarang",
		hideUsernameTip: "Apabila diaktifkan, pengguna lain tidak akan dapat melihat nama pengguna anda dalam senarai awam.",
	},

	kyc: {
		title: "Pengesahan Identiti",
		verifyIdentity: "Sahkan identiti anda",
		completeDesc: "Lengkapkan pengesahan identiti untuk memastikan akaun anda selamat dan membuka semua ciri.",
		failed: "Pengesahan gagal. Sila cuba lagi.",
		reVerify: "Sahkan semula",
		checkYouOut: "Mari sahkan identiti anda",
		prepareDoc: "Sediakan dokumen anda",
		prepareDocDesc: "Sediakan dokumen pengenalan yang sah.",
		useSmartphone: "Guna telefon pintar",
		useSmartphoneDesc: "Anda memerlukan telefon pintar untuk melengkapkan pengesahan.",
		scanQr: "Imbas kod QR",
		scanQrDesc: "Imbas kod QR dengan telefon anda untuk meneruskan pada peranti mudah alih.",
		noSmartphone: "Tiada telefon pintar?",
		completeOnMobile: "Lengkapkan pada mudah alih"
	},

	verify: {
		title: "Pengesahan",
		personalVerification: "Pengesahan Peribadi",
		weak: "Lemah",
		level1: "Tahap 1",
		personalInfo: "Maklumat Peribadi",
		personalInfoDesc: "Lengkapkan maklumat peribadi anda untuk meningkatkan keselamatan akaun anda.",
		verifyNow: "Sahkan Sekarang",
		level2: "Tahap 2",
		kycVerification: "Pengesahan KYC",
		kycDesc: "Lengkapkan pengesahan KYC untuk membuka had yang lebih tinggi dan akses penuh.",
		docTip: "Sila pastikan dokumen anda jelas dan sah sebelum menghantar."
	},

	personalInfo: {
		verify: "Pengesahan",
		completeInfo: "Lengkapkan Maklumat Anda",
		completeInfoDesc: "Isi butiran peribadi anda untuk melengkapkan pengesahan.",
		firstName: "Nama Pertama",
		paternalSurname: "Nama Keluarga Bapa",
		maternalSurname: "Nama Keluarga Ibu",
		contactNumber: "Nombor Hubungan",
		phoneUsed: "Nombor telefon ini telah digunakan.",
		contactEmail: "Email Hubungan",
		invalidEmail: "Alamat email tidak sah.",
		detailedAddress: "Alamat Terperinci",
		city: "Bandar",
		street: "Jalan",
		neighborhood: "Kejiranan",
		houseNumber: "Nombor Rumah",
		postalCode: "Poskod",
		save: "Simpan",
		male: "Lelaki",
		female: "Perempuan"
	},

	withdrawPassword: {
		changeTitle: "Tukar Kata Laluan Pengeluaran",
		setTitle: "Tetapkan Kata Laluan Pengeluaran",
		changeDesc: "Masukkan kata laluan lama anda dan tetapkan kata laluan pengeluaran baharu.",
		setDesc: "Tetapkan kata laluan pengeluaran untuk melindungi dana anda.",
		oldPlaceholder: "Kata Laluan Pengeluaran Lama",
		newPlaceholder: "Kata Laluan Pengeluaran Baharu",
		confirmPlaceholder: "Sahkan Kata Laluan Pengeluaran"
	},

	contactBirthday: {
		title: "Hari Lahir Kenalan",
		desc: "Ikat hari lahir kenalan untuk komunikasi yang lebih mudah. Maklumat peribadi anda akan terus dilindungi.",
		label: "Hari Lahir Kenalan",
		invalid: "Hari lahir tidak sah."
	},

	changePassword: {
		title: "Tukar Kata Laluan",
		expiredDesc: "Kata laluan anda telah tamat tempoh. Sila tetapkan kata laluan baharu untuk meneruskan.",
		verifyOldDesc: "Masukkan kata laluan lama anda dan tetapkan yang baharu.",
		passwordPlaceholder: "Kata Laluan Lama",
		newPlaceholder: "Kata Laluan Baharu",
		confirmPlaceholder: "Sahkan Kata Laluan Baharu",
		lengthError: "Kata laluan mestilah 6 hingga 30 aksara.",
		sameAsOld: "Kata laluan baharu tidak boleh sama dengan yang lama.",
		confirmRequired: "Sila sahkan kata laluan baharu anda.",
		notMatch: "Kata laluan tidak sepadan.",
		success: "Kata laluan berjaya ditukar",
		failed: "Gagal menukar kata laluan"
	},
	settingsNav: {
		title: "Tetapan",
		accountInfo: "Info Akaun",
		security: "Keselamatan"
	},
	verificationBirthday: {
		title: "Hari Lahir",
		securityTip: "Hari lahir untuk keselamatan akaun. Hanya anda yang boleh pautkannya.",
		clickSelectBirthday: "Klik para memilih hari lahir",
		invalidBirthday: "Hari lahir tidak sah",
		submitting: "Menyerahkan...",
		confirm: "Sahkan",
		cancel: "Batal",
		selectBirthday: "Pilih Hari Lahir",
		birthdayRequired: "Hari lahir diperlukan",
		updateBirthdayFail: "Gagal mengemas kini hari lahir",
		success: "Berjaya dikemas kini"
	}
};